import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { StripeEffects } from './+state/stripe.effects'
import { StripeFacade } from './+state/stripe.facade'

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([StripeEffects])],
  providers: [StripeFacade],
})
export class GbDashboardSharedDataAccessStripeModule {}
